import { render } from "./shell.vue?vue&type=template&id=432cf41f&ts=true"
import script from "./shell.vue?vue&type=script&lang=ts"
export * from "./shell.vue?vue&type=script&lang=ts"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__